export type LatLng = { lat: number; lng: number }
export type LatLngPerimeter = LatLng[]

function degreesToRadians(degrees: number): number {
  return (degrees * Math.PI) / 180
}
export function checkLatLngIsWithinDistance(
  latLng: LatLng,
  target: LatLng,
  distance: number,
): boolean {
  const earthRadius = 6371e3 // Earth's radius in meters

  const dLat = degreesToRadians(target.lat - latLng.lat)
  const dLng = degreesToRadians(target.lng - latLng.lng)

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(degreesToRadians(latLng.lat)) *
      Math.cos(degreesToRadians(target.lat)) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2)

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

  const distanceBetweenPoints = earthRadius * c

  return distanceBetweenPoints <= distance
}
